module.exports = __webpack_public_path__ + "static/media/telegram.3a3b78dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Support/icons/telegram.svg
// module id = 1515
// module chunks = 0